// Turunan status kesehatan kapal dari kesegaran sensor. Murni, nol efek samping.
// Bagian ikon SENGAJA gak ikut ke sini: shipIcons.js ngimpor 14 file .svg yang
// cuma bisa di-resolve webpack, jadi file ini gak akan bisa dites pakai node.
import { HEALTH_SENSOR_TYPES } from './deviceStatus.js';

// Ambang sensor non-GPS masih dianggap segar.
export const SENSOR_FRESH_SECONDS = 600;

// reduce, bukan Math.max(...spread): array puluhan ribu titik bikin
// "Maximum call stack size exceeded" karena spread jadi argumen fungsi.
export function isSensorFresh(dataArr, currTime, limitSeconds = SENSOR_FRESH_SECONDS) {
  if (!dataArr || dataArr.length === 0) return false;
  const latest = dataArr.reduce((max, d) => {
    const ts = d.timestamp || 0;
    return ts > max ? ts : max;
  }, 0);
  return (currTime - latest) < limitSeconds;
}

// Sensor kesehatan yang MEMANG dimiliki aset, dikurangi yang ditolak izin.
// Sensor yang ditolak izin bukan sensor mati, cuma gak boleh dicek role ini.
export function expectedHealthSensors(deviceTypes, deniedSensorTypes = []) {
  return [...new Set(
    (deviceTypes || [])
      .filter((t) => HEALTH_SENSOR_TYPES.includes(t))
      .filter((t) => !deniedSensorTypes.includes(t)),
  )];
}

/**
 * Status kesehatan yang menimpa hasil tahap GPS.
 * null = pertahankan status dari tahap GPS (online/offline).
 */
export function resolveHealthStatus({ expected, freshness, isGpsOnline }) {
  if (!expected || expected.length === 0) return null;
  if (isGpsOnline && !expected.every((t) => freshness[t])) return 'no-sensor';
  if (!isGpsOnline && expected.some((t) => freshness[t])) return 'no-gps';
  return null;
}

export const STATUS_LABELS = {
  online: 'Online',
  offline: 'Offline',
  'no-gps': 'No GPS',
  'no-sensor': 'No Sensor',
};

// Badge status di sidebar & popup.
export const STATUS_COLORS = {
  online: '#28a745',
  offline: '#ff3b30',
  'no-gps': '#9ca3af',
  'no-sensor': '#f97316',
};

// Garis trail di peta. Hijaunya sengaja lebih terang dari badge.
export const TRACK_COLORS = {
  online: '#28F385',
  offline: '#FF3B30',
  'no-gps': '#9CA3AF',
  'no-sensor': '#F97316',
};

// Busur lencana cluster kapal. Hijaunya sengaja beda lagi dari dua di atas.
export const CLUSTER_COLORS = {
  online: '#16b961',
  offline: '#FF3B30',
  'no-gps': '#9CA3AF',
  'no-sensor': '#F97316',
};

export function resolveStatus(ship) {
  if (ship.shipStatus) return ship.shipStatus;
  return ship.dataStatus ? 'online' : 'offline';
}

export function statusLabel(ship) {
  return STATUS_LABELS[resolveStatus(ship)] || 'Offline';
}

export function statusColor(ship) {
  return STATUS_COLORS[resolveStatus(ship)] || STATUS_COLORS.offline;
}

// Terima status mentah, bukan ship: switch lama di toggleTrail gak lewat resolveStatus.
export function trackColor(status) {
  return TRACK_COLORS[status] || TRACK_COLORS.offline;
}

export function clusterColor(status) {
  return CLUSTER_COLORS[status] || CLUSTER_COLORS.offline;
}
